export enum USER_STATUS_FILTERS {
  ALL = "All",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
